/**
 * Controllers
 * @module controllers
 */
define(function (require, exports) {

  'use strict';

  /**
   * Main controller
   * @ngInject
   * @constructor
   */
  function MainCtrl($scope, model, lpPortal, lpCoreBus, lpCoreUtils, $window, lpConstants, MobileAlertService, CommonService, TranslateService) {

    var self = this;
    const CTRL_CONSTANTS = {
      "SHOW_OLD_PASSWORD_VIEW" : "showOldPasswordView",
      "SHOW_NEW_PASSWORD_VIEW" : "showNewPasswordView",
      "NEW_PASSWORD" : "Reset Password",
      "CHANGE_PASSWORD" : "Change Password"
    };
    self.isValid = false;
    self.modalWindowOpen = false;
    self.isSuccess = false;
    self.isFail = false;
    self.errorCode = '';
    self.isServerError = false;
    self.isActiveUser = false;
    self.isOldPassword = true;
    self.isNewPassword = false;
    self.isConfirmPassword = false;
    self.changePasswordPayload = {
      oldPassword: '',
      newPassword: '',
      confirmPassword: ''
    };
    self.passwordRegex = lpConstants.REGEX.PASSWORD;
    self.alreadyHavingPassword = 1;

    /* --- Error Messages ---*/
    self.serverError = TranslateService.translate("abc.common.server.error");
    self.passwordError = TranslateService.translate("abc.common.password.validation.rules");
    self.passwordServerError = TranslateService.translate("abc.common.error.oops");
    self.successMessage = TranslateService.translate("abc.common.password.changed");
    self.passwordCompareError = TranslateService.translate("abc.manage_password.confirm.password.error.message");
    self.passwordComplexityError = TranslateService.translate("abc.manage_password.complexity.rules.message");
    self.isMobileNative = window.cxp && window.cxp.mobile ? true : false;

    self.toggleChangePasswordView = toggleChangePasswordView;

    if (self.isMobileNative) {
      lpCoreBus.subscribe( lpConstants.SUBSCRIBE.JSON_DATA, function(payload) {
        self.managePasswordFlow = payload.status;
	        if(payload.status == lpConstants.COMMON.CHANGE_PASSWORD){
	            self.alreadyHavingPassword = 1;
                CommonService.toggleTitlebar(true, CTRL_CONSTANTS.CHANGE_PASSWORD);
	            self.toggleChangePasswordView(CTRL_CONSTANTS.SHOW_OLD_PASSWORD_VIEW);
	        } else {
	            self.bindingStatus = payload.bindingStatus || 0;
	            self.alreadyHavingPassword = 0;
                CommonService.toggleTitlebar(true, CTRL_CONSTANTS.NEW_PASSWORD);
	            self.toggleChangePasswordView(CTRL_CONSTANTS.SHOW_NEW_PASSWORD_VIEW);
	        }
      });
      lpCoreBus.publish(lpConstants.PUBLISH.JSON_SEND);
    } else {
      //Web pub-sub
      lpCoreBus.subscribe('launchpad-retail.changePassword', function(payload) {
        self.managePasswordFlow = payload.status;
		      if(payload.status === lpConstants.COMMON.CHANGE_PASSWORD){
            self.bindingStatus = 0;
            self.isOldPassword = true;
          } else {
            self.bindingStatus = payload.bindingStatus;
            self.isOldPassword = false;
          }
	    });

    }

    self.redirectToLogin=function(){
      self.isMobileNative ? gadgets.pubsub.publish( lpConstants.PUBLISH.SIGNOUT ) : $window.location.href = lpPortal.root +'/'+lpPortal.name+'/sign-in';
    };

    self.logoutSession = function () {
      self.modalWindowOpen = false;
      logout();
    };

    self.hideModalWindow = function () {
      self.isSuccess = false;
      self.isFail = false;
      self.isServerError = false;
      self.modalWindowOpen = false;
      angular.element($("div[data-pid^='bg-container']")).removeAttr('style');
    };

    self.allowDoNext = function () {
      let result = false;
      if(self.isOldPassword) {
	      result = self.changePasswordPayload.oldPassword
	        && self.changePasswordPayload.newPassword
	        && self.changePasswordPayload.confirmPassword
	        && (self.changePasswordPayload.confirmPassword === self.changePasswordPayload.newPassword)
	        && (new  RegExp(self.passwordRegex).test(self.changePasswordPayload.confirmPassword));
      } else {
        result = self.changePasswordPayload.newPassword
      	        && self.changePasswordPayload.confirmPassword
      	        && (self.changePasswordPayload.confirmPassword === self.changePasswordPayload.newPassword)
      	        && (new  RegExp(self.passwordRegex).test(self.changePasswordPayload.confirmPassword));
      }
      return result;
    };

    self.validatePattern = function(event){
      self.isValid = false;
      var pattern = self.passwordRegex;
      var val = angular.element(event.target).val();
      if(val.length == 0){
        self.isValid = true;
        return true;
      }
      var returnVal =  new  RegExp(pattern).test(val);
      if(returnVal){
        self.isValid = true;
        return true;
      }
      else{
        self.isValid = false;
        return false;
      }
    };

    self.comparePassword = function(){
      return (self.changePasswordPayload.confirmPassword === self.changePasswordPayload.newPassword);
    };

    self.managePassword = function () {
      if (self.managePasswordFlow === lpConstants.COMMON.LOGIN_FIRST_TIME || self.managePasswordFlow === lpConstants.COMMON.CHANGE_PASSWORD) {
        self.updatePassword();
      } else {
        self.readyToResetPassword();
      }
    };
    self.checkComplexity = function(){
      //TODO only if password is valid
      if(self.isValid){
        self.isConfirmPassword = true;
        self.isNewPassword = false;
      }else{
        showNativeAlert(self.passwordComplexityError, clearFields, null, true);
      }
    }
    function clearFields(){
      self.changePasswordPayload.confirmPassword = '';
      self.changePasswordPayload.newPassword = '';
      $scope.$apply();
    }
		self.allowToSubmitOtp = function () {
          if ($("#txtForgotOtp").val().toString() !== '' && $("#txtForgotOtp").val().toString().length === 6) {
            angular.element('#submitForgotOtp').focus();
            return true;
          } else {
            return false;
          }
    };

    self.closeWindow = function () {
      self.otpWindowOpen = false;
      self.clearOtp();
    };

    self.clearOtp = function () {
      self.otp = null;
      $("#txtForgotOtp").val('');
    };

    self.updatePassword = function (){
      if(self.isMobileNative) {
        let comparePass = self.comparePassword();
        if (!comparePass) {
          handleInvalidNewPassword();
          return;
        }
      }
      var payload = {
        "oldPassword": self.changePasswordPayload.oldPassword,
        "newPassword": self.changePasswordPayload.newPassword,
      };
      self.alreadyHavingPassword === 0 ? delete payload.oldPassword : angular.noop;
      if (self.managePasswordFlow === lpConstants.COMMON.SET_PASSWORD) {
          delete payload.oldPassword;
          model.changePasswordSave.save(payload).$promise.then(function (success) {
      	        self.isSuccess = true;
      	        self.isFail = false;
      	        self.isServerError = false;
      	        CommonService.toggleTitlebar(false);
      	        if(self.alreadyHavingPassword === 0){
      	          nextStep();
      	        }else{
      	          showModalWindow();
      	        }
      	      }, function (error) {
      	        self.isSuccess = false;
      	        self.isServerError = (error.data.errors && error.data.errors.length > 0 && error.data.errors[0].code === lpConstants.CUSTOM_ERROR_CODES.SERVER_ERROR);
      	        self.isFail = !self.isServerError;
      	        showException(self.isServerError, error.data);
      	      });
      } else if (self.managePasswordFlow === lpConstants.COMMON.CHANGE_PASSWORD){
	      model.changePasswordUpdate.put(payload).$promise.then(function (success) {
	        self.isSuccess = true;
	        self.isFail = false;
	        self.isServerError = false;
	        CommonService.toggleTitlebar(false);
	        if(self.alreadyHavingPassword === 0){
	          nextStep();
	        }else{
	          showModalWindow();
	        }
	      }, function (error) {
	        self.isSuccess = false;
	        self.isServerError = (error.data.errors && error.data.errors.length > 0 && error.data.errors[0].code === lpConstants.CUSTOM_ERROR_CODES.SERVER_ERROR);
	        self.isFail = !self.isServerError;
	        showException(self.isServerError, error.data);
	      });
      }
    };
    function showException(isServerError, response){
      if (isServerError) {
        if (self.isMobileNative) {
          CommonService.serverErrorAlert(logout);
          return;
        }
        else {
          self.errorMessage = self.passwordServerError;
        }
      }
      else if (response.errorMessages && response.errorMessages.length > 0) {
        self.errorMessage = response.errorMessages[0].errorMessage;
      }
      else {
        self.errorMessage = self.passwordServerError;
      }
      self.isMobileNative ? handleInvalidOldPassword(self.errorMessage) : showModalWindow();
    }
    function nextStep(){
      lpCoreBus.publish(lpConstants.PUBLISH.LOAD_SUB_PAGE, {'relationship':'Child', 'target':lpConstants.PAGE.VERIFICATION_METHODS, 'jsonData':{}});
    }

    function handleInvalidOldPassword(error) {
      self.changePasswordPayload = {
        oldPassword: '',
        newPassword: '',
        confirmPassword: ''
      };
      showNativeAlert(error, self.toggleChangePasswordView, CTRL_CONSTANTS.SHOW_OLD_PASSWORD_VIEW, true);
    }

    function handleInvalidNewPassword() {
      self.changePasswordPayload.newPassword = '';
      self.changePasswordPayload.confirmPassword = '';
      showNativeAlert(self.passwordCompareError, self.toggleChangePasswordView, CTRL_CONSTANTS.SHOW_NEW_PASSWORD_VIEW, true);
    }

    function toggleChangePasswordView(view, outOfContext) {
      self.isOldPassword = view === CTRL_CONSTANTS.SHOW_OLD_PASSWORD_VIEW;
      self.isNewPassword = view === CTRL_CONSTANTS.SHOW_NEW_PASSWORD_VIEW;
      self.isConfirmPassword = false;
      outOfContext ? $scope.$apply() : angular.noop();
    }

    function showNativeAlert(message, callBack, callBackParam, context) {
      const buttons = [MobileAlertService.getOkButton()];
      buttons[0].callback = function (){if(callBack) callBack(callBackParam, context); }
      MobileAlertService.show(message, buttons);
    }

    function showModalWindow() {
      self.modalWindowOpen = true;
      angular.element($("div[data-pid^='bg-container']")).attr('style','overflow:visible');
    }
    function showOTPWindow() {
      self.otpWindowOpen = true;
      angular.element($("div[data-pid^='bg-container']")).attr('style', 'overflow:visible');
    }

    function logout() {
      CommonService.logout();
    }
    self.submitOtp = function () {
      self.otp = '' + self.otp;
      self.otpWindowOpen = false;
      var payload = {
        "newPassword": self.changePasswordPayload.newPassword,
        "otp": $("#txtForgotOtp").val()
      };
      changePassword(payload);
    };

    function showConfirmationWindow() {
      self.confirmationWindowOpen = true;
      angular.element($("div[data-pid^='bg-container']")).attr('style', 'overflow:visible');
    }

    self.closeConfirmationWindow = function () {
      self.confirmationWindowOpen = false;
      angular.element($("div[data-pid^='bg-container']")).removeAttr('style');
      logout();
    };

    //Methods for forgotpassword flow
    self.presubmitValidation = function () {
      var payload = {
        "password": self.changePasswordPayload.newPassword
      };

      model.changePasswordComplexity.save(payload).$promise.then(function (success) {
        if(self.isMobileNative){
          lpCoreUtils.showOtpWindow(function(otp){
            self.otpMobile = otp.data;
            var payload = {
              "newPassword": self.changePasswordPayload.newPassword,
              "otp":(otp && otp.data) ? otp.data :  ''
            };
            changePassword(payload);
          });
        } else {
          //Need to do with binding status
          //self.bindingStatus === 0 ? changePassword({newPassword: self.changePasswordPayload.newPassword}) : showOTPWindow();
          self.bindingStatus === 0 ? self.updatePassword() : showOTPWindow();
        }
      }, function (error) {
        self.isSuccess = false;
        if (error.data.errorMessage) {
          showValidationWindow(error.data.errorMessage, true)
          self.button = 'abc.common.button.close';
        } else {
          showValidationWindow(self.passwordServerError, false);
          self.button = 'abc.common.end.session';
        }
      });
    };

    self.readyToResetPassword = function(){
      let comparePass = self.comparePassword();
      if(comparePass){
        self.presubmitValidation();
      }else{
        handleInvalidNewPassword();
      }
    };

    function changePassword(payload) {
      model.changeForgotPassword.save(payload).$promise.then(function (success) {
        self.isSuccess = true;
        CommonService.toggleTitlebar(false);
        self.isFailure = false;
        !self.isMobileNative ? showConfirmationWindow() : angular.noop;
      }, function (error) {
        self.isSuccess = false;
        self.isFailure = true;
        if (error && error.data && error.data.errorMessage) {
          self.errorMessage = error.data.errorMessage;
        }
        if(self.isMobileNative){
          const buttons = [{
            type: lpConstants.MOBILE_SDK_BUTTONS.POSITIVE,
            text: TranslateService.translate("abc.common.button.ok"),
            callback: logout
          }];
          MobileAlertService.show(self.errorMessage, buttons);
        }else{showConfirmationWindow();}
      });
    }

    function showValidationWindow(errorMessage, serverError) {
      self.passwordError = true;
      self.serverError = serverError;
      self.errorMessage = errorMessage;
      angular.element($("div[data-pid^='bg-container']")).attr('style', 'overflow:visible');
    }

  }

  MainCtrl.prototype.$onInit = function () {
    // Do initialization here
  };

  module.exports = MainCtrl;
});



//////////////////
// WEBPACK FOOTER
// ./scripts/controllers/main-ctrl.js
// module id = 9
// module chunks = 0